export default {
    ca: {
        title: 'Esborrar el mapa',
        titleColaboratiu: 'Deixar de col·laborar en el mapa',
        message: 'Segur que vols esborrar el mapa?',
        messageColaboratiu: 'Segur que vols deixar de col·laborar en el mapa ',
        nota: 'En esborrar el mapa desapareixerà tant de la teva galeria com de la pública.',
        notaColaboratiu: 'A l\'esborrar el mapa desapareixerà de la teva galeria.',
        esborrar: 'Esborrar',
        esborrarColaboratiu: 'Deixar de col·laborar',
        messageError: 'No s\'ha pogut esborrar el mapa',
        emailSubject: 'Instamaps. Usuari col·laborador esborrat',
        emailContent: 'L\'usuari ${email} ha estat esborrat com a col·laborador del mapa "${nom}".',        
        cancelar: 'Cancel·lar',
        responseOK: 'Has estat esborrat com a col·laborador',
        responseKO: 'No ha estat possible esborrar-te com a col·laborador',
    },
    es: {
        title: 'Borrar el mapa',
        titleColaboratiu: 'Dejar de colaborar en el mapa',
        message: 'Seguro que quieres borrar el mapa?',
        messageColaboratiu: 'Seguro que quieres dejar de colaborar en el mapa ',
        nota: 'Al borrar el mapa desaparecerá tanto de tu galería como de la pública.',
        notaColaboratiu: 'Al borrar el mapa desaparecerá de tu galería.',
        esborrar: 'Borrar',
        esborrarColaboratiu: 'Dejar de colaborar',
        messageError: 'No se ha podido borrar el mapa',
        emailSubject: 'Instamaps. Usuario colaborador borrado',
        emailContent: 'El usuario ${email} se ha borrado como colaborador del mapa "${nom}".',        
        cancelar: 'Cancelar',
        responseOK: 'Has sido borrado como colaborador',
        responseKO: 'No ha sido posible borrarte como colaborador',
    },
    en: {
        title: 'Delete the map',
        titleColaboratiu: 'Stop collaborating in this map',
        message: 'Are you sure you want to delete the map?',
        messageColaboratiu: 'Are you sure you want to delete yourself as a map contributor of ',
        nota: 'Deleting the map will make it disappear from your gallery as well as from the public one.',
        notaColaboratiu: 'Deleting the map will disappear from your gallery.',
        esborrar: 'Delete',
        esborrarColaboratiu: 'Stop collaborating',
        messageError: 'Could not delete map',
        emailSubject: 'Instamaps. Contributing user deleted',
        emailContent: 'The user ${email} has been deleted as contributor from map "${nom}".',
        cancelar: 'Cancel',
        responseOK: 'You have been removed as map contributor',
        responseKO: 'It has not been possible to remove you as a contributor',
    },
};



// WEBPACK FOOTER //
// ./src/perfil/components/borrar-modal/borrar-modal-translations.js